import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.css'
import '@fortawesome/fontawesome-free/scss/fontawesome.scss'
import '@fortawesome/fontawesome-free/scss/solid.scss'
import 'core-js'
import stickybits from 'stickybits'
import 'aos/dist/aos.css'
import AOS from 'aos'
import anchorScroll from 'anchor-scroll'
import Swiper from 'swiper'

AOS.init({
  once: true,
  duration: 1300
})

anchorScroll.init({
  updateUrl: false,
  offset: 0,
  ease: 'inOutQuad',
  duration: 900,
  selector: '.smmoth-scroll'
})

function triggerAnimation () {
  var members = document.querySelectorAll('.member-wrapper')
  if (members) {
    Array.prototype.forEach.call(members, (member) => {
      window.addEventListener('scroll', function (event) {
        var memberRect = member.getBoundingClientRect()
        if (memberRect.top >= 0 &&
          memberRect.left >= 0 &&
          memberRect.right <= (window.innerWidth || this.document.documentElement.clientWidth) &&
          memberRect.bottom - 350 <= (window.innerHeight || this.document.documentElement.clientHeight)
        ) {
          member.classList.add('animation-trigger')
        }
      })
    })
  }
}
triggerAnimation()
/*
var swiper = new Swiper('.swiper-container', {
  direction: 'vertical',
  // effect: 'fade',
  speed: 700,
  spaceBetween: 0,
  slidesPerView: 1
})

function swiperOpt () {
  var swipcont = document.querySelector('.swiper-container')
  var testing = document.querySelectorAll('.member-main-wrapper')
  if (testing) {
    Array.prototype.forEach.call(testing, (test) => {
      test.addEventListener('wheel', (evt) => {
        const delta = Math.sign(evt.deltaY)

        if (delta > 0) {
          if (swiper.activeIndex !== 3) {
            evt.preventDefault()
          }
          swiper.slideNext()
        } else {
          if (swiper.activeIndex !== 0) {
            evt.preventDefault()
          }
          swiper.slidePrev()
          if (swiper.isEnd) {
            setInterval(() => {
              evt.preventDefault()
            }, 100)
          }
          if (swiper.isBeginning) {
            setInterval(() => {
              evt.preventDefault()
            }, 100)
          }
        }
      })
    })
  }
}
swiperOpt()*/

//Waypoint.refreshAll();
/*
if ($(window).width() > 768) { }
          $( ".produkteMenu" ).animate({            
              top: "70"            
          }, 200, function() {
              // Animation complete.
          });





var waypoint = new Waypoint({
  element: document.getElementById('options-property-example'),
  handler: function(direction) {
    notify('Offset option: ' + this.options.offset)
  },
  offset: '50%'
})


//#photo-1
// #text-1

*/
stickybits('.member-image-main-wrapper');


var animating = false;
$('.member-bio-wrapper .name').each(function(){
  var waypoint = new Waypoint({
  element: $(this), 
  handler: function(direction) {
    var current = parseInt($(this.element).attr('id').slice(-1));
    var next = parseInt($(this.element).attr('id').slice(-1))+1;
    var all = $('.member-bio-wrapper .name').length;
   // console.log(current + ' ' + next + ' ' + all);
    //console.log($(this.element).attr('id').slice(-1)); 
    if (direction === 'down') {
      if ($(window).width() >= 990) {
        if(current!=all) {
          if(!animating) {
            animating = true;
            $(".member-image-wrapper img").addClass('hide');  
            $(".member-bio-wrapper").addClass('hide');  
            $(".member-bio-wrapper .name").removeClass("active");
            $('html, body').animate({
                scrollTop: $("#text-"+next).offset().top-100
            }, 100, function() { 
              animating = false;
              $("#photo-"+next).removeClass('hide');
              $("#text-"+next).parent().removeClass('hide');
              $("#text-"+next).addClass("active");
            }); 
        
          }
        }
      }

     
    }
  
  },
  offset:"-50" 
 });
});



$('#section-4').each(function(){
  var waypoint = new Waypoint({
  element: $(this), 
  handler: function(direction) {


    if (direction === 'down') {
      
      if ($(window).width() >= 990) {
        $(".member-image-wrapper img").addClass('hide');  
        $(".member-bio-wrapper").addClass('hide');  
        $(".member-bio-wrapper .name").removeClass("active");
        $("#photo-1").removeClass('hide');
        $("#text-1").parent().removeClass('hide');
        $("#text-1").addClass("active");
      }

     
    }
  
  },
  offset:"0%" 
 });
});

$('.member-bio-wrapper').each(function(){
  var waypoint = new Waypoint({
  element: $(this), 
  handler: function(direction) {
    var current = parseInt($(this.element).children(".name").attr('id').slice(-1));
    var prev = parseInt($(this.element).children(".name").attr('id').slice(-1))-1;
    var all = $('.member-bio-wrapper .name').length;
   

    if (direction === 'up') {
      //console.log(current + ' ' + prev + ' ' + all);
      if ($(window).width() >= 990) {
        if(prev!=0 || current!=all) {
          //console.log(animating);
          if(!animating) {
            animating = true;
            $(".member-image-wrapper img").addClass('hide');  
            $(".member-bio-wrapper").addClass('hide');  
            $(".member-bio-wrapper .name").removeClass("active");
            $('html, body').animate({
                scrollTop: $("#text-"+current).offset().top-100
            }, 200, function() { 
              animating = false;
              $("#photo-"+current).removeClass('hide');
              $("#text-"+current).parent().removeClass('hide');
              $("#text-"+current).addClass("active");
            }); 
           
            
          }
        }
      }

     
    }
  
  },
  offset:"-90%" 
 });
});